import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForCoopPartnerComponent extends Component {
  // Defaults
  defaultColumns = ['id', 'name', 'city', 'coopTypes', 'cmsModified'];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'name',
      sortable: true,
      isMainColumn: true,
    },
    {
      property: 'zipcode',
      sortable: true,
    },
    {
      property: 'city',
      sortable: true,
    },
    {
      property: 'street',
      sortable: true,
    },
    {
      property: 'coopTypes',
      type: 'relation',
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
